/**
 * 组织组件实体
 */

import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    rff
} from '../../incs/FunHelper';

import CNF from '../../incs/Config';

const MODULENAME = '组织信息';

const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [prefix, setPrefix] = useState('');
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setPrefix('');
        setName('');
        setAddress('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setPrefix(props.record.prefix);
            setName(props.record.name);
            setAddress(props.record.address);
            setDescription(props.record.description);
        }
    }, [props.record]);


    const ok = () => {
        if (prefix === '') {
            message.error('前缀不能为空！');
            return;
        }
        if (name === '') {
            message.error('名称不能为空！');
            return;
        }

        $.ajax({
            url: CNF.api + 'org/infos' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'prefix': prefix,
                'name': name,
                'address': address,
                'description': description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };

    return (
        <>
            {contextHolder}
            <Modal
                width={500}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>{rff}前缀</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setPrefix(e.target.value)}
                            value={prefix}
                            disabled={props.record ? true : false}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>{rff}名称</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>{rff}地址</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setAddress(e.target.value)}
                            value={address}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>描述</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='描述可写在这里...'
                            autoSize={{ minRows: 3, maxRows: 5 }}
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity